import { createStore, applyMiddleware } from 'redux';
import { thunk as thunkMiddleware } from 'redux-thunk';
import rootReducer from './reducer';
export var composedEnhancer = applyMiddleware(thunkMiddleware);
var store = createStore(rootReducer, undefined, composedEnhancer);
export default store;
